const parallaxVideoDefinitions = [
  {
    page: '14',
    src: './video/parallax-video/14-ensayommilo_p_3Kkbps.mp4',
    poster: './video/parallax-video/14-ensayommilo_p_3Kkbps-poster.jpg',
    left: '0%',
    top: '15%',
    width: '40%',
    mobile: { right: '5%', top: '-8%', width: '90%' },
    parallax: 0.12,
  },
  {
    page: '17',
    src: './video/parallax-video/17-Video4_000_3Kkbps.mp4',
    poster: './video/parallax-video/17-Video4_000_3Kkbps-poster.jpg',
    right: '-15%',
		top: '10%',
		width: '40%',
		mobile: {
			right: '5%',
			bottom: '-5%',
			width: '80%',
      parallax: 0.12,
		},
  },
  {
    page: '19',
    src: './video/parallax-video/19-IMG_1604_p_3Kkbps.mp4',
    poster: './video/parallax-video/19-IMG_1604_p_3Kkbps-poster.jpg',
    right: '-5%',
		bottom: '10%',
		width: '35%',
		mobile: {
			left: '5%',
			bottom: '28%',
			width: '70%',
      parallax: 0.12,
		},
  },
  {
    page: '19',
    src: './video/parallax-video/19-LBNCASINOCONSTRUCTIONVIEW_p_3Kkbps.mp4',
    poster: './video/parallax-video/19-LBNCASINOCONSTRUCTIONVIEW_p_3Kkbps-poster.jpg',
    left: '-5%',
    bottom: '10%',
    width: '40%',
    mobile: {
      left: '5%',
			top: '-5%',
			width: '70%',
      parallax: 0.12,
    },
  },
  {
    page: '20',
    src: './video/parallax-video/20-IMG_2934_p_3Kkbps.mp4',
    poster: './video/parallax-video/20-IMG_2934_p_3Kkbps-poster.jpg',
    right: '-15%',
    top: '10%',
    width: '45%',
    mobile: {
      left: '10%',
      bottom: '-5%',
      width: '80%',
      parallax: 0.12,
    },
  },
  {
    page: '21',
    src: './video/parallax-video/21-IMG_2807_p_3Kkbps.mp4',
    poster: './video/parallax-video/21-IMG_2807_p_3Kkbps-poster.jpg',
    right: '-5%',
    bottom: '5%',
    width: '25%',
    mobile: {
      right: '5%',
      bottom: '-10%',
      width: '40%',
      parallax: 0.12,
    },
  },
  {
    page: '23',
    src: './video/parallax-video/23-LA_BOLA_NEGRA_creditsLoop3Kkbps.mp4',
    poster: './video/parallax-video/23-LA_BOLA_NEGRA_creditsLoop3Kkbps-poster.jpg',
    right: '20%',
    top: '5%',
    width: '17%',
    parallax: 0,
  },
  {
    page: '23',
    src: './video/parallax-video/23-LBN-Editing_4up_3Kkbps.mp4',
    poster: './video/parallax-video/23-LBN-Editing_4up_3Kkbps-poster.jpg',
    left: '15%',
    top: '5%',
    width: '17%',
    parallax: 0,
  },
  {
    page: '34',
    src: './video/parallax-video/34-Rau_l componiendo _Mira que nos acechan__p.mp4',
    poster: './video/parallax-video/34-Rau_l componiendo _Mira que nos acechan__p-poster.jpg',
    left: '-15%',
    bottom: '10%',
    width: '50%',
    clickToPlay: true,
    mobile: {
      left: '5%',
      top: '-10%',
      width: '90%',
      parallax: 0.12,
    },
  },
  {
    page: '34',
    src: './video/parallax-video/34-coro soldadito_p_3Kkbps.mp4',
    poster: './video/parallax-video/34-coro soldadito_p_3Kkbps-poster.jpg',
    left: '40%',
    bottom: '10%',
    width: '50%',
    clickToPlay: true,
    mobile: {
      right: '5%',
      top: '20%',
      width: '90%',
      parallax: 0.12,
    },
  },
];

export default parallaxVideoDefinitions;